import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { get } from 'lodash'
import { compose, pure } from 'recompose'
import { CircleLoader, ModuleLoader } from 'components/loaders'
import { Button, Module } from 'components/misc'
import styles from './labelsOverview.styl'
import { Select } from '../../../fields'
import { mapLabels } from 'helpers/mapForSelect'
import { form } from '../../../../helpers/decorators'
import { Form } from '../../../layout'
import { ORGANIZATION_HIERARCHY } from '../../../../constants/enums'


const enhance = compose(
  connect(({ auth }) => ({
    activeOrganization: auth.organization
  })),
  injectIntl,
  pure,
  form({
        form: 'labelsSelector'
    }),
)

class LabelsOverview extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    availableLabels: PropTypes.array.isRequired,
    onFetchAvailableLabels: PropTypes.func.isRequired,
    onAssignPersonLabel: PropTypes.func.isRequired,
    onUnassignPersonLabel: PropTypes.func.isRequired,
    onGetPersonLabels: PropTypes.func.isRequired,
    participantId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    labels: PropTypes.object.isRequired
  }

    getLabels = labels => {
        const labelsCompList = []

        labels.forEach(l => {
            switch(get(l, 'orgType')) {
                case ORGANIZATION_HIERARCHY.NAO.value:
                    labelsCompList.push(this.getLabel(l, 'nao'))
                    break
                case ORGANIZATION_HIERARCHY.RO.value:
                    labelsCompList.push(this.getLabel(l, 'nao'))
                    break
                case ORGANIZATION_HIERARCHY.SOA.value:
                    labelsCompList.push(this.getLabel(l, 'nao'))
                    break
                case ORGANIZATION_HIERARCHY.OA.value:
                    labelsCompList.push(this.getLabel(l, 'nao'))
                    break
                case ORGANIZATION_HIERARCHY.IC.value:
                    labelsCompList.push(this.getLabel(l, 'nao'))
                    break
                case ORGANIZATION_HIERARCHY.AU.value:
                    labelsCompList.push(this.getLabel(l, 'au'))
                    break
                case ORGANIZATION_HIERARCHY.IAC.value:
                    labelsCompList.push(this.getLabel(l, 'au'))
                    break
                default: break
            }
        })

        return labelsCompList
    }

    getLabel = (l, stylePrefix) => {
        return(<div className={styles.labelWrapper}>
            <div className={`${get(l,'canBeModified') ? styles[`${stylePrefix}EditableLabel`] : styles[`${stylePrefix}Label`]}`}>
                {get(l, 'name')}
            </div>
            {get(l,'canBeModified') && <Button
                type="button"
                className={styles.deleteButton}
                onClick={() => this.handleRemoveLabel(get(l, 'id'))}
            >
                X
            </Button>}
        </div>)
    }

    handleSelectLabel = async(label) => {
      const { participantId, organizationId } = this.props

      await this.props.onAssignPersonLabel(participantId, get(label, 'value'))
      await this.props.onFetchAvailableLabels(participantId, organizationId)
      participantId && this.props.onGetPersonLabels(participantId)
    }

    handleRemoveLabel = async(id) => {
        const { participantId, organizationId } = this.props

        await this.props.onUnassignPersonLabel(id)
        await this.props.onFetchAvailableLabels(participantId, organizationId)
        participantId && this.props.onGetPersonLabels(participantId)
    }

  render () {
    const { data, availableLabels, labels } = this.props

      const personLabelLoading = get(labels, 'person.loading')

    const loading = get(data, 'loading')

    return (
      <div>
        {loading &&
          <ModuleLoader
            moduleWidth={400}
            moduleHeight={185}
          />
        }

        {!loading &&
          <Module
            title="Labels"
            intlKey="moduleTitle.labels"
            primary
            grid
          >
              <div>
                  <Form
                      className="form"
                      encType="multipart/form-data"
                  >
              <div className="row">
                <div className={`col-xs-12`}>
              <Select
                  label="Available Labels"
                  intlKey="label.available_labels"
                  name="availableLabels"
                  options={mapLabels(availableLabels, true)}
                  onSelectChange={label => this.handleSelectLabel(label)}
                  clearable={false}
              />
                  </div>
              </div>

            <div className="row">
              <div className={`col-xs-12 ${styles.labelsWrapper}`}>

                  {personLabelLoading &&
                  <CircleLoader size={20} />}

                  {data && !personLabelLoading && this.getLabels(data)}
              </div>
            </div>

                  </Form>
              </div>
          </Module>
        }
      </div>
    )
  }
}

export default enhance(LabelsOverview)
